import {
  REFRESH_TOKEN,
  RESEND_MFA_CODE,
  SET_ATTENDANCE_DOCUMENT_NUMBER,
  SIGNOUT_REQUEST,
  USER_LOGIN,
  USER_LOGIN_WITH_MFA,
} from "../actions/login";

const INITIAL_STATE = {
  isFetching: false,
  didInvalidate: false,
  token: false,
  blockPasswordReset: false,
  roles: [],
  userName: "",
  documentNumberAttendance: null,
  loginMfa: {
    isFetching: false,
    didInvalidate: false,
  },
  resendMfaCode: {
    isFetching: false,
    didInvalidate: false,
  },
};

const hasBadRequestErrorType = (action) => {
  const payloadErrorType = action?.payload?.response?.data?.errors?.[0]?.type;
  if (payloadErrorType === "BadRequest") {
    return true;
  }

  const firstArrayErrorType = action?.payload?.data?.[0]?.type;
  if (firstArrayErrorType === "BadRequest") {
    return true;
  }

  return false;
};

const auth = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case `${USER_LOGIN}_REJECTED`:
      return {
        ...state,
        isFetching: false,
        didInvalidate: true,
        token: false,
        blockPasswordReset: hasBadRequestErrorType(action),
      };
    case `${USER_LOGIN}_PENDING`:
      return {
        ...state,
        isFetching: true,
        didInvalidate: false,
      };
    case `${USER_LOGIN}_FULFILLED`: {
      if (!action.payload?.token) {
        return {
          ...state,
          isFetching: false,
          didInvalidate: false,
          blockPasswordReset: false,
        };
      }
      const nombreRol = action.payload.roles.nombre;
      const roles = {
        [`${nombreRol}`]: true,
        tipo: action.payload.roles.tipo,
      };
      return {
        ...state,
        isFetching: false,
        didInvalidate: false,
        token: action.payload.token,
        blockPasswordReset: false,
        roles,
        userName: action.payload.userName,
      };
    }
    case `${USER_LOGIN_WITH_MFA}_REJECTED`:
      return {
        ...state,
        loginMfa: {
          ...state.loginMfa,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${USER_LOGIN_WITH_MFA}_PENDING`:
      return {
        ...state,
        loginMfa: {
          ...state.loginMfa,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${USER_LOGIN_WITH_MFA}_FULFILLED`:
      return {
        ...state,
        loginMfa: {
          ...state.loginMfa,
          isFetching: false,
          didInvalidate: false,
        },
      };
    case `${RESEND_MFA_CODE}_REJECTED`:
      return {
        ...state,
        resendMfaCode: {
          ...state.resendMfaCode,
          isFetching: false,
          didInvalidate: true,
        },
      };
    case `${RESEND_MFA_CODE}_PENDING`:
      return {
        ...state,
        resendMfaCode: {
          ...state.resendMfaCode,
          isFetching: true,
          didInvalidate: false,
        },
      };
    case `${RESEND_MFA_CODE}_FULFILLED`:
      return {
        ...state,
        resendMfaCode: {
          ...state.resendMfaCode,
          isFetching: false,
          didInvalidate: false,
        },
      };
    case REFRESH_TOKEN:
      return {
        ...state,
        token: action.payload,
      };


    case SET_ATTENDANCE_DOCUMENT_NUMBER:
      return {
        ...state,
        documentNumberAttendance: action.payload,
      }
    case SIGNOUT_REQUEST:
      return {
        ...INITIAL_STATE,
        documentNumberAttendance: state.documentNumberAttendance,
      }

    default:
      return state;
  }
};

export default auth;
